import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Grid, Box } from '@mui/material';
import logo from '../../assests/images/logo.png';
import bookmarkIcon from '../../assests/images/bookmark.svg';

export default function LoginHeader() {
  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: (theme) => theme.palette.grey[800],
          height: '50px'
        }}>
        <Toolbar sx={{ marginTop: '-5px' }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            {/* Grid Item 1 - Brand Name */}
            <Grid item>
              <Box>
                <img src={logo} alt="Logo" />
              </Box>
            </Grid>
            <Grid item>
              <a
                href="https://pepsico.sharepoint.com/:p:/t/TPO-Gen3/ET9TCC-0SpNBjHFYQMFjU44BrXsQrl8LFTwZbPFEF0_95A?e=wo4aTt"
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={bookmarkIcon}
                  alt="icon"
                  style={{ position: 'relative', top: '4px', right: '10px', cursor: 'pointer' }}
                />
              </a>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
}
